import { render } from "./MobileAppComponent.vue?vue&type=template&id=28794189"
import script from "./MobileAppComponent.vue?vue&type=script&lang=js"
export * from "./MobileAppComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__